import { useQuery } from "@tanstack/react-query";
import { themesRepo } from "@/lib/repositories";
import type { ThemesListParams } from "@/features/themes/types";
import { mapThemeToTopicStat } from "./map-theme-to-topic-stat";

type Ranking = NonNullable<ThemesListParams["ranking"]>;

const TOP_LIMIT = 5;

/**
 * Top-5 topics served directly by the ranked topics list:
 * - `most_solved` → most resolved situations (Partie 3, "les plus résolus")
 * - `least_understood` → lowest success rate (Partie 3, "les moins compris")
 * The backend returns them already ordered, so no client-side sorting.
 */
export function useTopThemes(ranking: Ranking) {
  const query = useQuery({
    queryKey: ["stats", "top-themes", ranking],
    queryFn: () =>
      themesRepo.fetchList({
        ranking,
        with_success_rate: true,
        limit: TOP_LIMIT,
      }),
    select: (data) => data.results.map(mapThemeToTopicStat),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
